import { createContext } from 'react';

const AppContext = createContext();

export const AuthContext = createContext();

export const PosContext = createContext();

export const ConfigContext = createContext();

export const PrescriptionContext = createContext();

export default AppContext;
